// The confirmation every trader sees after submitting ANY request — regular
// RFQ, managed, صنّع فكرتك, ask a factory (owner, 2026-10-03).
//
// It replaces every earlier confirmation that promised a faster or specific
// time ("a dedicated account manager will contact you on WhatsApp within
// hours", "suppliers will contact you soon"). Offers take 3–7 working days in
// practice; promising less sets a trader up to feel ignored on day two.
//
// AR and EN are the owner's wording, verbatim. ZH is ours (the trader UI is
// trilingual) — have a Chinese reader check it.
// Mirrors the mobile repo's src/lib/requestReceivedCopy.js — keep identical.
const COPY = {
  ar: {
    title: '✓ استلمنا طلبك',
    body: 'العروض توصلك عادةً خلال ٣ إلى ٧ أيام عمل، وتختلف حسب نوع المنتج، وتوفّر المصانع، ومواسم الإجازات في الصين.',
    notify: 'وبنبلغك أول ما يوصلك عرض.',
  },
  en: {
    title: '✓ We received your request',
    body: 'Offers usually arrive within 3 to 7 working days, depending on the product, factory availability, and holiday seasons in China.',
    notify: "We'll notify you as soon as an offer arrives.",
  },
  zh: {
    title: '✓ 我们已收到您的需求',
    body: '报价通常在 3 至 7 个工作日内送达，具体取决于产品类型、工厂档期以及中国的节假日。',
    notify: '一有报价，我们会第一时间通知您。',
  },
};

export function requestReceivedCopy(lang = 'ar') {
  return COPY[lang] || COPY.en;
}

// Body + notify as one string, for places that can only show text (an alert,
// a chat bubble, a notice line).
export function requestReceivedText(lang = 'ar') {
  const c = requestReceivedCopy(lang);
  return `${c.body}\n${c.notify}`;
}
